import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { stringify } from 'query-string';

// CONSTANTS
import { ROUTE_SHOWS_AND_MOVIES_DISCOVER } from '@/constants/routes';
import { contentTypes } from '@/constants/watchList';

// COMPONENTS
import RouterLink from '@/components/Link';

// STYLES
import ServiceCardStyled from './styles';

function ServiceCard({ data }) {
  const [t] = useTranslation();

  const search = stringify(
    {
      apps: [data.id],
      appsType: 1,
      type: [contentTypes.show, contentTypes.movie],
    },
    {
      arrayFormat: 'comma',
      skipEmptyString: true,
    },
  );

  const appLink = `${ROUTE_SHOWS_AND_MOVIES_DISCOVER}?${search}`;

  return (
    <RouterLink to={appLink}>
      <ServiceCardStyled className="service-card" $backgroundImage={data.background}>
        <div className="service-card__img-wrapper">
          <img src={data.thumbnail} alt={data.name} />
        </div>
        <Typography component="p" variant="h6" className="service-card__title" align="center">
          {t('profileMyApps.popularOn.title', { appName: data.name })}
        </Typography>
      </ServiceCardStyled>
    </RouterLink>
  );
}

ServiceCard.propTypes = {
  data: PropTypes.object.isRequired,
};

export default React.memo(ServiceCard);
